import { tv } from 'tailwind-variants';
import { useSelector } from 'react-redux';

import useInteractions from 'lib/hooks/useInteractions';
import useComments from 'lib/hooks/useComments';

import { selectCurrentUser } from 'features/auth/slice';

import {
  flash,
  Icon,
  recordsContain,
} from '@frontendmentorio/design-system-v2';

import withAuth from 'features/shared/withAuth';

const AuthButton = withAuth(({ ...props }) => <button {...props} />);

const styles = tv({
  slots: {
    wrapper: [
      'bg-gray-100',
      'flex',
      'font-secondary',
      'gap-3',
      'h-min',
      'items-center',
      'justify-center',
      'rounded-full',
      'px-4',
      'py-1',
      'w-min',
    ],
    icon: [
      'text-neutral-500',
      'transition-transform',
      'hover:-translate-y-[2px]',
    ],
  },
  variants: {
    isUpvoted: {
      true: {
        wrapper: ['bg-blue-500/10', 'text-blue-500'],
        icon: ['text-blue-500'],
      },
    },
    isDisabled: {
      true: {
        wrapper: ['bg-gray-100/80', 'text-neutral-500'],
        icon: ['text-neutral-500'],
      },
    },
  },
});

export default function UpvoteButton({ className, comment, disabled }) {
  const { upvote } = useComments();
  const { getInteractions } = useInteractions();
  const { upvotes } = getInteractions(comment);
  const currentUser = useSelector(selectCurrentUser);
  const isUpvoted = recordsContain(upvotes, currentUser);

  const { wrapper, icon } = styles({ isDisabled: disabled, isUpvoted });

  const handleClick = async () => {
    try {
      await upvote(comment);
    } catch (error) {
      flash.error(error.message);
    }
  };

  return (
    <AuthButton
      aria-label={isUpvoted ? 'Remove upvote' : 'Upvote comment'}
      className={wrapper({ class: className })}
      disabled={disabled}
      onClick={handleClick}
    >
      <Icon className={icon()} name="chevron-up" style="solid" />
      <span>{upvotes.length}</span>
    </AuthButton>
  );
}
